/*
 * Banner with video intro (snippets/hero.liquid).
 *
 * When the frame scrolls into view the intro image holds for data-hold ms,
 * then crossfades into the video, which restarts from the top and keeps
 * looping. data-cta-delay ms after that the button pops in.
 *
 * Reduced motion: the image stays, the video never plays, the button shows
 * straight away.
 */
(function () {
  'use strict';

  if (customElements.get('hero-video-intro')) return;

  customElements.define(
    'hero-video-intro',
    class extends HTMLElement {
      connectedCallback() {
        this.timers = [];
        this.frame = this.closest('.video-background');
        this.player = this.frame && this.frame.querySelector('video-background');

        const hold = parseInt(this.dataset.hold, 10) || 0;
        this.ctaDelay = parseInt(this.dataset.ctaDelay, 10) || 0;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.holdStill();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.timers.push(setTimeout(() => this.start(), hold));
          },
          {threshold: 0.6}
        );
        this.observer.observe(this);
      }

      start() {
        // The video has been playing unseen under the image; rewind so the
        // reveal shows it from the first frame.
        const video = this.player && this.player.querySelector('video');
        if (video) {
          try {
            video.currentTime = 0;
          } catch (e) {}
          const playing = video.play();
          if (playing) playing.catch(() => {});
        }

        this.classList.add('is-playing');
        if (this.frame) this.frame.classList.remove('is-intro');

        this.timers.push(setTimeout(() => this.classList.add('is-cta-visible'), this.ctaDelay));
      }

      holdStill() {
        this.classList.add('is-cta-visible');

        // video-background loads and plays the video by itself; stop it each
        // time it tries. `play` doesn't bubble, so listen in the capture phase.
        if (this.player && this.frame && this.frame.classList.contains('is-intro')) {
          this.onPlay = (e) => e.target.pause();
          this.player.addEventListener('play', this.onPlay, true);
        }
      }

      disconnectedCallback() {
        this.timers.forEach(clearTimeout);
        if (this.observer) this.observer.disconnect();
        if (this.onPlay) this.player.removeEventListener('play', this.onPlay, true);
      }
    }
  );
})();
